import { createFileRoute } from '@tanstack/react-router';
import { MenuTitle } from '../../types'

export const packageStaticData = {
  menuTitle: MenuTitle.Packages
};
export const Route = createFileRoute('/_private-routes/package')({
  staticData: packageStaticData
});
